// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

/* Axios, Vue-axios */
import axios from "axios";
import VueAxios from "vue-axios";

/**
 * Api URL depending on the environment
 */

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

Vue.use(VueAxios, axios);

// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// PDF make
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Vue.use(BootstrapVue);
Vue.use(pdfMake);
Vue.use(pdfFonts);

// Vue Modal
import VModal from "vue-js-modal";
Vue.use(VModal);

// Vue Pretty Checkbox
import PrettyCheckbox from "pretty-checkbox-vue";
Vue.use(PrettyCheckbox);

// JSON EXCEL
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

/*
 * v-tooltip
 * https://github.com/Akryum/v-tooltip
 */
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

/*
 * Switch
 * http://vue-js-toggle-button.yev.io/
 */
import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

/*
 * Vue Lazyload
 * https://github.com/hilongjw/vue-lazyload
 */
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

/**
 * Vue backtotop
 * https://github.com/caiofsouza/vue-backtotop
 */
import BackToTop from "vue-backtotop";
Vue.use(BackToTop);

/**
 * Vue scroll to
 */
import VueScrollTo from "vue-scrollto";
var VueScrollToDefaultOptions = {
  container: "body",
  duration: 800,
  easing: "ease", //easing: 'linear',
  offset: -60,
  cancelable: true,
  onStart: false,
  onDone: function(element) {
    element.classList.add("marked");
    setTimeout(() => {
      element.classList.remove("marked");
    }, 2000);
  },
  onCancel: false,
  x: false,
  y: true
};
Vue.use(VueScrollTo, VueScrollToDefaultOptions);

/**
 * Vue-i18n
 */
import VueI18n from "vue-i18n";
import { messages } from "./translations/messages";
import { lang } from "./translations/lang";

const numberFormats = {
  pl: {
    currency: {
      style: "currency",
      currency: "PLN",
      currencyDisplay: "symbol"
    }
  },
  en: {
    currency: {
      style: "currency",
      currency: "EUR"
    }
  }
};

Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: "pl", // when no EN translate
  messages, // set locale messages
  numberFormats
});

/* PATH */

Vue.config.productionTip = true;

/* Filters */

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("format_type", function(value, type) {
  if (!value) return "";
  if (type == "decimal") return parseFloat(value);
  return value;
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js